module.exports = __webpack_public_path__ + "static/img/iconfont.ceafa0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1610540494052
// module id = o2Ba
// module chunks = 1